import * as yup from "yup";

const Schema = yup.object().shape({
	governorates: yup
		.array()
		.min(1, "Select at least one governorate"),

	startDate: yup
		.date()
		.min(new Date(), "Date must not be before today")
		.required("Start date is required"),

	endDate: yup
		.date()
		.min(
			yup.ref("startDate"),
			(startDate) =>
				`End date must be later than or equal to start date`
		)
		.required("End date is required"),

	budget: yup
		.number()
		.min(1)
		.required("Budget is required"),

	interestedPlaces: yup
		.array()
		.min(1, "Select at least one place of interest"),

	languages: yup
		.array()
		.min(1)
		.of(yup.string().required())
		.required(),

	noOfPeople: yup
		.array()
		.min(1)
		.of(yup.string().required())
		.required(),
});

export default Schema;
